import dayjs from 'dayjs';

// สร้าง URLSearchParams สำหรับยิง GET /expenses — logic นี้เหมือนกันเป๊ะทุก tab (Backlog/Future/Archive/
// All/Rejected/Labor) เดิม copy วางซ้ำอยู่ในแต่ละไฟล์ tab ก๊อปแล้วแก้ที่เดียวไม่ครบทุกจุดได้ง่าย ดึงมารวมไว้
// จุดเดียวแทน — statusOptions ต้องส่งชุดของ tab นั้นๆ มาด้วย (แต่ละ tab มี STATUS_OPTIONS ไม่เหมือนกัน) เพื่อ
// map key ที่เลือกใน statusFilters กลับเป็นรายชื่อ status จริงที่จะส่งเป็น query param `statuses`
export function buildExpensesQuery({
  tab,
  page,
  size,
  sortBy,
  sortDir,
  search,
  projectId,
  budgetId,
  filterVat,
  filterWithholding,
  statusFilters,
  statusOptions,
  dateRange,
  dateFilterField,
  advSearch = {},
}) {
  const q = new URLSearchParams({ tab, page, size, sortBy, sortDir });
  if (search) q.set('search', search);
  if (projectId) q.set('findProject', projectId);
  if (budgetId) q.set('findBudget', budgetId);
  if (filterVat) q.set('includesVat', 'true');
  if (filterWithholding) q.set('hasWithholdingTax', 'true');

  const activeStatusValues = (statusOptions || [])
    .filter((o) => o.key !== 'ALL' && statusFilters?.includes(o.key))
    .flatMap((o) => o.statuses);
  if (activeStatusValues.length) q.set('statuses', [...new Set(activeStatusValues)].join(','));

  // เลือกกรองได้ทีละ field เท่านั้น (date = วันที่ขอรับเงิน, createdAt = วันที่สร้างรายการ) ตาม dateFilterField
  if (dateRange?.[0] || dateRange?.[1]) {
    const startParam = dateFilterField === 'createdAt' ? 'createdAtStart' : 'dateStart';
    const endParam = dateFilterField === 'createdAt' ? 'createdAtEnd' : 'dateEnd';
    if (dateRange?.[0]) q.set(startParam, dayjs(dateRange[0]).toISOString());
    if (dateRange?.[1]) q.set(endParam, dayjs(dateRange[1]).toISOString());
  }

  const {
    name: searchName,
    code: searchCode,
    payee: searchPayee,
    applicant: searchApplicant,
    projectNumber: searchProjectNumber,
    budgetNumber: searchBudgetNumber,
    netAmount: searchNetAmount,
  } = advSearch;
  if (searchName) q.set('searchName', searchName);
  if (searchCode) q.set('searchCode', searchCode);
  if (searchPayee) q.set('searchPayee', searchPayee);
  if (searchApplicant) q.set('searchApplicant', searchApplicant);
  if (searchProjectNumber) q.set('searchProjectNumber', searchProjectNumber);
  if (searchBudgetNumber) q.set('searchBudgetNumber', searchBudgetNumber);
  if (searchNetAmount) q.set('searchNetAmount', searchNetAmount);

  return q;
}
